import { Error } from '../interface/upplm.common.interface';
export class PlacardInformation {
    placardId: string;
    confirmed: boolean;
    placardStatus: string;
    companyName: string;
    confirmedPlacardInformation: ConfirmedPlacardInformation;
    errors: Error[];
}

export class ConfirmedPlacardInformation {
    locationDetails: LocationDetails;
    contactDetails: Contact[];
    placardDetails: PlacardDetails;
    pickupDetails: PickupDetails;
    notifications: Contact[];
    placardVerification: PlacardVerification;
    placardLocation: PlacardLocation;
}
export class LocationDetails {
    clientKey: string;
    nickname: string;
    address: Address = new Address();
    clientKeys: clientKeys[];
}
export class PickupDetails {
    pickupPlanType: string;
    selectedDays: SelectedDays[];
}
export class PlacardDetails {
    locationType: string;
    placardTypeKey: string;
    placardSizeKey: string;
    placardType: string;
    placardSize: string;
}
export class Contact {
    contactType: string;
    name: string;
    email: string;
    phone: string;
    phoneExt: string;
    locale: string;
}
export class SelectedDays {
    dayOfWeekCode: string;
    selectedPreferredTime: string;
    selectedLatestTime: string;
}

export class Notifications {
    contact: Contact;
}


export class PlacardVerification {
    pickupStartDate: string;
    placardImage: PlacardImage;
    customerFacingStartDate: string;
}

export class PlacardImage {
    name: string;
    contents: string;
    extension: string;
    fullName: string;
}
export class PlacardLocation {
    metalBoxInd: boolean;
    lockCombination: string;
    pickupLocation: string;
    placardLocation: string;
    additionalLocationDetails: string;
}

export class Address {
    addressLine1: string;
    cityTown: string;
    stateProvince: string;
    countryCode: string;
    postalCode: string;
}
export class clientKeys {
    clientKey: string;
    nickname: string;
}

export class OperationalDetails {
    regionNumber: string;
    regionName: string;
    districtNumber: string;
    districtName: string;
    buildingNumber: string;
    buildingName: string;
    buildingMnemonic: string;
    centerNumber: string;
    centerName: string;
    centerType: string;
}

export class AutoApproveCriteria {
    sectionIsCandidate: string;
    multiClientKeyIndicator: string;
    bwsPendingIndicator: string;
    autoApproveAllowed: string;
}

export class AutoApproveResults {
    approvedChanges: ApprovedChanges[];
    updatedSections: string[];
}

export class ApprovedChanges {
    sectionName: string;
    fields: Field[];
}

export class Field {
    field: string;
    value: string;
    action: string;
    rejectionReason: string;
}